/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PutApiV1ExamId202,
  PutApiV1ExamId400,
  PutApiV1ExamId401,
  PutApiV1ExamId404,
  PutApiV1ExamId500,
  PutApiV1ExamIdMutationRequest,
  PutApiV1ExamIdMutationResponse,
  PutApiV1ExamIdPathParams,
} from "../../types/examEvaluationController/PutApiV1ExamId.ts";
import { examUpdateEditorViewModelSchema } from "../examUpdateEditorViewModelSchema.ts";

export const putApiV1ExamIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<PutApiV1ExamIdPathParams>;

/**
 * @description (Accepted) Requisição aceita.
 */
export const putApiV1ExamId202Schema =
  z.any() as unknown as ToZod<PutApiV1ExamId202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const putApiV1ExamId400Schema =
  z.any() as unknown as ToZod<PutApiV1ExamId400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const putApiV1ExamId401Schema =
  z.any() as unknown as ToZod<PutApiV1ExamId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const putApiV1ExamId404Schema =
  z.any() as unknown as ToZod<PutApiV1ExamId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const putApiV1ExamId500Schema =
  z.any() as unknown as ToZod<PutApiV1ExamId500>;

export const putApiV1ExamIdMutationRequestSchema = z.lazy(
  () => examUpdateEditorViewModelSchema,
) as unknown as ToZod<PutApiV1ExamIdMutationRequest>;

export const putApiV1ExamIdMutationResponseSchema = z.lazy(
  () => putApiV1ExamId202Schema,
) as unknown as ToZod<PutApiV1ExamIdMutationResponse>;
